export function addZero(i) {
  let j = i;
  if (j < 10) {
    j = `0${j}`;
  }
  return j;
}

export function getMonth(i) {
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  return months[i - 1];
}

export function formatDate(date, noGroupDay = true) {
  const messageDate = new Date(date);
  let hours = messageDate.getHours();
  const minutes = messageDate.getMinutes();
  const ampm = hours >= 12 ? 'pm' : 'am';
  hours %= 12;
  if (ampm === 'pm' && hours === 0) {
    hours = 12;
  }
  const messageTime = `${addZero(hours)}:${addZero(minutes)} ${ampm}`;
  if (noGroupDay) {
    return messageTime;
  }
  const days = messageDate.getDay();
  let theDay = 'Today';
  if (days === 2) {
    theDay = 'Yesterday';
  } else if (days > 2) {
    theDay = `${messageDate.getDate()}/${messageDate.getMonth() + 1}/${messageDate.getFullYear()}`;
  }
  return `${messageTime} ${theDay}`;
}

export function displayDate(date) {
  const messageDate = new Date(date);
  const currentDate = new Date();
  const diffTime = Math.abs(messageDate.getTime() - currentDate.getTime());
  const days = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  let theDay = 'Today';
  if (days === 2) {
    theDay = 'Yesterday';
  } else if (days > 2) {
    const theMonth = parseInt(messageDate.getMonth(), 10) + 1;
    theDay = `${messageDate.getDate()}/${theMonth}/${messageDate.getFullYear()}`;
  }
  return theDay;
}

export function capitalFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
